<template>
    <section class="block-product-listing"
             :class="{ loading: loading, detail: onDetail }"
             :style="{ backgroundColor: bgColor }"
    >
        <transition name="fade" appear>
            <div class="container" v-if="products && products.length">
                <h2 class="block-listing-heading">{{ title }}</h2>
                <div class="row">
                    <div class="col-lg-3 col-md-6 column"
                         v-for="(product, key) in products"
                         :key="key"
                         :data-lb-id="product.id"
                         v-for-callback="{ key: key, array: products, callback: loopCallback }"
                    >
                        <ThemeProduct :data="product"
                                      :btn-text="productBtnText"
                                      :btn-text-in-cart="productBtnTextInCart"
                                      :btn-text-remove="productBtnTextRemove"
                                      :change-cart-status="shouldChangeCartStatus"
                                      :discounted="discounted"
                                      :discount-percentage="discountPercentage"
                                      :data-page-area="dataPageArea"
                                      :should-add-to-cart="addToCart"
                        />
                    </div>
                </div>

                <div class="cta" v-if="btnText && btnLink && discounted != 1">
                    <a :href="btnLink" class="button primary js-ga-event"
                       :data-page-area="dataPageArea"
                       data-type="button"
                       data-name="show-more"
                       :data-text="btnText"
                       data-action="href"
                       :data-destination-url="btnLink"
                    >
                        {{ btnText }}
                        <img src="/img/icons/btn-arrow-right.svg"
                             loading="lazy"
                             alt=""
                        >
                    </a>
                </div>
            </div>
        </transition>

        <template v-if="loading">
            <ComponentLoader />
        </template>
    </section>
</template>

<script>
import { onMounted, ref, inject } from 'vue'
import { setElHeight } from '../../../functions/helpers'

import ThemeProduct from '../templates/ThemeProduct'
import ComponentLoader from '../../globals/ComponentLoader'

import axios from 'axios'

export default {

    props: [
        'styles',
        'title',
        'productsIds',
        'btnText',
        'btnLink',
        'productBtnText',
        'productBtnTextInCart',
        'productBtnTextRemove',
        'bgColor',
        'onDetail',
        'shouldChangeCartStatus',
        'discounted',
        'discountPercentage',
        'dataPageArea',
        'addToCart'
    ],

    components: {
        ThemeProduct,
        ComponentLoader
    },

    setup(props) {

        const loading    = ref(true)
        const products   = ref(null)
        const cartStatus = ref('addToCart')
        const constants  = inject('constants')

        let discountFlag       = 0,
            discountPercentage = 0

        onMounted( () => {
            if ( props.discounted && props.discounted !== '' && props.discounted !== null ) {
                discountFlag = 1
                discountPercentage = props.discountPercentage
            }

            fetchProducts()
        })

        function fetchProducts() {
            axios.post('/api/get-products', {
                productsIds: props.productsIds,
                currentLocale: constants.locale,
                discountFlag: discountFlag,
                discountPercentage: discountPercentage
            }).then( response => {
                if (!products.length) {
                    loading.value = false
                }
                if ( response.status === 200 ) {
                    products.value = response.data.products
                }
                else
                    flash('Niečo sa pokazilo.', 'danger')
            }).catch( error => flash(error.message, 'danger'))
        }

        function loopCallback() {
            loading.value = false

            if ( constants.clientWidth > 767 ) {
                setElHeight(document.querySelectorAll('.block-product-listing .product h4'))
                setElHeight(document.querySelectorAll('.block-product-listing .product .bottom'))
                setElHeight(document.querySelectorAll('.block-product-listing .product .description'))
                setElHeight(document.querySelectorAll('.block-product-listing .product .excerpt'))
            }
        }

        return {
            loading,
            products,
            cartStatus,
            loopCallback
        }
    }
}
</script>
